import { h, Component } from 'preact';

export default class FooterView extends Component {
    render() {
        return (
            <footer class="js-footer">
                <div class="contain-width flex-container--row">
                    <div class="flex-col-3">
                        <h3>Connect</h3>
                        <ul>
                            <li>
                                <a class="footer-icon facebookIcon" href="https://www.facebook.com/NOAADigitalCoast" title="NOAA Coastal Services on Facebook">
                                    <span class="hidden-508">Facebook</span>
                                </a>
                                <a class="footer-icon twitterIcon" href="https://twitter.com/NOAADigCoast" title="NOAA Coastal Services on Twitter">
                                    <span class="hidden-508">Twitter</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://coast.noaa.gov/survey.html">Customer Satisfaction Survey</a>
                            </li>
                            <li>
                                <a href="//coast.noaa.gov/gallery/" title="The Office for Coastal Management's Photo Gallery">Multimedia Gallery</a>
                            </li>
                            <li><a href="//coast.noaa.gov/gallery/newsletter.html" title="The Office for Coastal Management's Newsletter Archives">Newsletter Gallery</a></li>
                            <li>
                                <a href="//coast.noaa.gov/contactform/" title="Contact NOAA Office for Coastal Management">Contact Us</a>
                            </li>
                        </ul>
                    </div>
                    <div class="flex-col-3">
                        <h3>Explore</h3>
                        <ul>
                            <li><a href="/about/" title="">About</a></li>
                            <li><a href="/czm/" title="Coastal Zone Management">Coastal Zone Management</a></li>
                            <li><a href="https://coralreef.noaa.gov/" title="Coral Reef Conservation">Coral Reef
                                Conservation</a></li>
                            <li><a href="//coast.noaa.gov/digitalcoast/" title="Digital Coast">Digital Coast</a></li>
                            <li><a href="//coast.noaa.gov/nerrs" title="National Estuarine Research Reserves">National Estuarine
                                Research Reserves</a></li>
                        </ul>
                    </div>
                    <div class="flex-col-3">
                        <h3>From the Office</h3>
                        <ul>
                            <li><a href="//coast.noaa.gov/idiq/" title="Contracting Vehicles for Governmental Organizations">Contracting Assistance</a></li>
                            <li><a href="/about/employment/" title="Employment Opportunities">Employment</a></li>
                            <li><a href="//coast.noaa.gov/fellowship/" title="Coastal Management Fellowship">Fellowship
                                Programs</a></li>
                            <li><a href="//coast.noaa.gov/funding/index.html" title="Funding Opportunities">Funding
                                Opportunities</a></li>
                        </ul>
                    </div>
                    <div class="flex-col-3">
                        <h3>More</h3>
                        <ul>
                            <li><a href="//coast.noaa.gov/PrivacyPolicy/privacyPolicy.html" title="">Privacy Policy</a></li>
                            <li><a href="https://www.noaa.gov/disclaimer.html" title="">Disclaimer</a></li>
                            <li><a href="https://usa.gov/" title="">USA.gov</a></li>
                            <li><a href="https://oceanservice.noaa.gov/" title="">National Ocean Service</a></li>
                            <li><a href="https://www.noaa.gov/" title="">National Oceanic and Atmospheric Administration</a>
                            </li>
                            <li><a href="https://www.commerce.gov/" title="">United States Department of Commerce</a></li>
                        </ul>
                    </div>
                    <aside class="flex-col-12 text-center">
                        <p class="text-small italic">
                            Website Owner: <a href="//coast.noaa.gov">NOAA Office for Coastal Management</a> | Last Modified:
                            <span id="ocm_frontend_last_modified">06/04/2020</span>
                        </p>
                    </aside>
                </div>
            </footer>
        );
    }
}
